module.exports = require("./../../_gen/starling/display/DisplayObjectContainer");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/display/DisplayObjectContainer.js
// module id = 166
// module chunks = 0